<template>
  <div class="form-group with-icon-left-mod">
    <div class="input-group">
      <select style="margin-left: 20px" :id="idInput" :name="idInput" :disabled="disabledInput">
        <option v-for="value in optionsInput" :value="value.id" :key="value.id" :selected="value.id === optionSelected">{{ value.value }}</option>
      </select>
      <i :class="'fa icon-left input-icon '+iconInput"></i>
      <label class="control-label" :for="idInput">{{labelInput}}</label><i class="bar"></i>
      <small class="help text-secondary">
        <slot></slot>
      </small>
    </div>
  </div>
</template>

<script>

import { TheMask } from 'vue-the-mask'
export default {
  name: 'SelectIconGroup',
  components: { TheMask },
  props: {
    idInput: {
      type: String,
      required: true
    },
    iconInput: {
      type: String,
      required: true
    },
    labelInput: {
      type: String,
      required: true
    },
    optionsInput: {
      type: Array,
      required: false,
      default: function () {
        return [{
          id: '',
          value: 'Selecione uma opção'
        }]
      }
    },
    optionSelected: {
      type: [String, Number],
      required: false,
      default: function () {
        return ''
      }
    },
    disabledInput: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>

<style scoped>

</style>
